import React from 'react';
const UpdateStaff = () => {
  return <div>UpdateStaff</div>;
};
export default UpdateStaff;
